import { render, staticRenderFns } from "./match-agent-modal.vue?vue&type=template&id=4f0bf5c2&"
import script from "./match-agent-modal.vue?vue&type=script&lang=js&"
export * from "./match-agent-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "match-agent-modal.vue"
export default component.exports